module.exports = __webpack_public_path__ + "img/1_036.cd2e94ee.jpg";